import {Component, OnInit,} from '@angular/core';
import {FormBuilder, FormGroup, Validators,} from '@angular/forms';
import {HttpClient,} from '@angular/common/http';
import {LoginUserVO,} from '@models/system-vo/login-user-vo';
import {MessageLevel,} from '@models/system-vo/message-level';
import {FileUtil,
        Logger,
        LoginInfoService,
        MessageProvider,
        MessageStackService,
        ScreenMessageHandler,
        SmsMenuPage,
        SmsErrorPage,
        StringUtil,
        SystemConstant,
        ValidationService,
        WindowService,} from '@services/index';
import {SMS009NameUpdateOutVO,} from '@pages/sms009-name-update/sms009-name-update-out-vo';
import * as Const_SMS009 from '@pages/sms009-name-update/sms009-name-update-const';
import {Title,} from '@angular/platform-browser';

@Component({
  selector: 'app-sms009-name-update',
  templateUrl: './sms009-name-update.html',
  styleUrls: ['./sms009-name-update.scss',],
})
/*****************************************************/
/* 処　理：SMS009 氏名変更登録 画面
/*
/* 概　要：氏名変更 処理
/*
/* 更新日：2025/01/08 HARAGU 00011_SMS機能等の導入支援
/*****************************************************/
export class SMS009NameUpdate implements OnInit {
  smsForm!: FormGroup;         // 画面フォーム
  loginUserVO!: LoginUserVO;   // セッション情報
  dispId!: string;             // ログ表示用ID
  lngType!: string;            //  言語区分

  // コンテンツエリア：style.width 設定用
  windowsWidth = this.constant.DEFAULT_DEVICE_SCREEN_WIDTH + 'px';

  // ボタン操作可否
  isEnableBtnSend = true;
  isEnableBtnMenu = true;

  // 画面項目（ラベル入れ替え用）
  public lblName!: string;
  public lblNameSei!: string;
  public lblNameMei!: string;
  public lblKanaSei!: string;
  public lblKanaMei!: string;
  public lblBirthDay!: string;
  public lblMessage01!: string;
  public lblMessage02!: string
  public lblMessage03!: string;
  public lblMessage04!: string;
  public lblMessage05!: string;
  public lblTel01!: string;
  public lblTel02!: string;
  public lblBtnSend!: string;
  public lblBtnMenu!: string;
  public lblScreenName!: string;

  /**
   * デフォルトコンストラクタ
   */
  constructor(
    private constant: SystemConstant,
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private logger: Logger,
    private messageProvider: MessageProvider,
    private windowService: WindowService,
    private titleService: Title,
    private screenMessage: ScreenMessageHandler,
    private smsMenuPage: SmsMenuPage,
    private smsErrPage: SmsErrorPage,
    public fileUtil: FileUtil,
    public loginInfoService: LoginInfoService,
    public stringUtil: StringUtil,
    public validationService: ValidationService
  ) {
    const connVo: LoginUserVO = this.loginInfoService.getLoginUserInfo();
    if (connVo && connVo.hashId != null && !this.stringUtil.isEmpty(connVo.hashId)
        && connVo.accessToken  != null && !this.stringUtil.isEmpty(connVo.accessToken)
        && connVo.refreshToken != null && !this.stringUtil.isEmpty(connVo.refreshToken)) {

      // ログイン情報を取得
      this.loginUserVO = connVo;

      // ログ表示用ID・言語区分セット
      this.dispId = this.loginUserVO.keiyakuInfoId.toString();
      this.lngType = this.loginUserVO.languageType;

    } else {

      // エラーログ出力
      this.logger.error('SMS00901M005E');

      // ログイン情報が取得出来ない場合、エラー画面へ遷移（予期せぬエラー）
      const messageStack = new MessageStackService(MessageLevel.ERROR);
      messageStack.add({messageId: 'SMS99901M013E',});
      this.smsErrPage.transition(messageStack, '', '', constant.DEFAULT_LANGUAGE_TYPE);
      return;
    }
  }

  /**
   * 初期処理(ngOnInit).
   */
  ngOnInit(): void {
    // 画面オブジェクト
    this.smsForm = this.fb.group({
      txtNameSei: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(10),
          this.validationService.seiZenkakuValidator(),
        ],
      ],
      txtNameMei: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(10),
          this.validationService.meiZenkakuValidator(),
        ],
      ],
      txtKanaSei: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(20),
          this.validationService.seiKanaValidator(),
        ],
      ],
      txtKanaMei: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(20),
          this.validationService.meiKanaValidator(),
        ],
      ],
    });

    // 初期表示
    this.formInit();
  }

  /* **************************************************************
   * 初期表示
   * **************************************************************/
  formInit(): void {
    try {
      // ログ出力
      this.logger.info('SMS00901M001I', this.dispId, Const_SMS009.INIT_NAME);

      // 初期表示API処理
      this.getInitData(Const_SMS009.API_INIT_PATH, Const_SMS009.INIT_NAME);

      // デバイスの横幅がデフォルト値未満の場合、横幅を調整する
      if (this.constant.DEFAULT_DEVICE_SCREEN_WIDTH > window.innerWidth) {
        this.logger.debug('■ content-area style.width:' + window.innerWidth);
        this.windowsWidth = window.innerWidth + 'px';
      }

      // ログ出力
      this.logger.info('SMS00901M002I', this.dispId, Const_SMS009.INIT_NAME);

    } catch (ex) {
      this.logger.error('SMS00901M001E', this.dispId, Const_SMS009.INIT_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 初期表示API処理
   * @param {string} path パスAPI
   * @param {string} btnName ボタン名
   */
  private getInitData(path: string, btnName: string): void {

    this.logger.debug(this.dispId + ' ■ 09 start-- getInitData');

    // APIパラメータ設定
    const apiVo = {
      keiyakuInfoId: this.loginUserVO.keiyakuInfoId,
      shouninNo: this.loginUserVO.shouninNo,
    }

    // ログ出力（API入力情報）
    this.logger.debug(this.dispId + ' ■ 09 URL：[' + path + ']');
    this.logger.debug(this.dispId + ' ■ 09 ApiIn   keiyakuInfoId：' + apiVo.keiyakuInfoId);
    this.logger.debug(this.dispId + ' ■ 09 ApiIn   shouninNo    ：' + apiVo.shouninNo);

    // 初期表示API
    this.logger.info('SMS00901M003I', this.dispId, btnName);
    this.httpClient.post<SMS009NameUpdateOutVO>(path, apiVo).subscribe({
      next: (resp) => {
        this.logger.info('SMS00901M004I', this.dispId, btnName);
        if (resp != null) {
          // 初期表示API 返却情報設定
          this.getInitApiReturnInfo(resp);

        } else {
          // エラー画面へ遷移（予期せぬエラー）
          this.logger.error('SMS00901M003E', this.dispId);
          const messageStack = new MessageStackService(MessageLevel.ERROR);
          messageStack.add({messageId: 'SMS99901M013E',});
          this.transitErrPage(messageStack);
        }
        return;
      },
      error: (err: MessageStackService | Error) => {
        // エラーログ
        this.logger.error('SMS00901M004E', this.dispId);

        // Errorの場合
        if (err instanceof Error) {
          // 共通例外処理
          this.commonException(err);
          return;
        }
        // MessageStackの場合
        if (err instanceof MessageStackService && err.messages.length > 0) {
          const messageStack: MessageStackService = new MessageStackService(MessageLevel.ERROR);
          for (const messageError of err.messages) {
            this.logger.debug(this.dispId + ' ■ 09 messageId ：' + messageError.messageId);
            this.logger.error(messageError.messageId);
            messageStack.add({messageId: messageError.messageId,});
          }
          // エラー画面へ遷移
          this.transitErrPage(messageStack);
          return;
        }
      },
    });
  }

  /**
   * 初期表示API 返却情報設定
   *
   * @param {SMS009NameUpdateOutVO} resp API返却情報
   * @returns -
   */
  getInitApiReturnInfo(resp: SMS009NameUpdateOutVO): void {

    this.logger.debug(this.dispId + ' ■ 09 start-- getInitApiReturnInfo');

    // ログ出力（API出力情報）
    this.logger.debug(this.dispId + ' ■ 09 ApiOut  sei     ：' + resp['sei']);
    this.logger.debug(this.dispId + ' ■ 09 ApiOut  mei     ：' + resp['mei']);
    this.logger.debug(this.dispId + ' ■ 09 ApiOut  birthday：' + resp['birthday']);

    // 画面文言（言語区分により変換）
    // {1}　{2} 様
    this.lblName = (this.messageProvider.getMessageString({messageId: 'SMS009' + this.lngType + 'M001F',},  false) || '').replace('{1}', resp['sei']).replace('{2}', resp['mei']);
    // 姓
    this.lblNameSei = this.messageProvider.getMessageString({messageId: 'SMS009' + this.lngType + 'M002F',},  false) || '';
    // 名
    this.lblNameMei = this.messageProvider.getMessageString({messageId: 'SMS009' + this.lngType + 'M003F',},  false) || '';
    // セイ
    this.lblKanaSei = this.messageProvider.getMessageString({messageId: 'SMS009' + this.lngType + 'M004F',},  false) || '';
    // メイ
    this.lblKanaMei = this.messageProvider.getMessageString({messageId: 'SMS009' + this.lngType + 'M005F',},  false) || '';

    // 生年月日
    const sYy = resp['birthday'].substring(0, 4);
    const sMm = resp['birthday'].substring(4, 6);
    const sDd = resp['birthday'].substring(6, 8);

    // 生年月日　{1}年{2}月{3}日
    this.lblBirthDay = (this.messageProvider.getMessageString({messageId: 'SMS009' + this.lngType + 'M006F',},  false) || '').replace('{1}', sYy).replace('{2}', sMm).replace('{3}', sDd);

    // ※氏名の更新・反映にはお時間を要する場合がございます。
    this.lblMessage01 = this.messageProvider.getMessageString({messageId: 'SMS009' + this.lngType + 'M007F',},  false) || '';
    // ※ご注意
    this.lblMessage02 = this.messageProvider.getMessageString({messageId: 'SMS009' + this.lngType + 'M008F',},  false) || '';
    // この画面でご契約者の変更はお受けできません。
    this.lblMessage03 = this.messageProvider.getMessageString({messageId: 'SMS009' + this.lngType + 'M009F',},  false) || '';
    // 変更のご相談は、下記カスタマーセンターまでお電話ください。
    this.lblMessage04 = this.messageProvider.getMessageString({messageId: 'SMS009' + this.lngType + 'M010F',},  false) || '';
    // カスタマーセンター
    this.lblMessage05 = this.messageProvider.getMessageString({messageId: 'SMS009' + this.lngType + 'M011F',},  false) || '';

    // tel:0570030660（リンク文字）
    this.lblTel01 = this.messageProvider.getMessageString({messageId: 'SMS999' + this.lngType + 'M004F',},  false) || '';
    // 0570-030-660
    this.lblTel02 = this.messageProvider.getMessageString({messageId: 'SMS999' + this.lngType + 'M003F',},  false) || '';

    // 送信
    this.lblBtnSend = this.messageProvider.getMessageString({messageId: 'SMS009' + this.lngType + 'M012F',},  false) || '';
    // メニューへ戻る
    this.lblBtnMenu = this.messageProvider.getMessageString({messageId: 'SMS009' + this.lngType + 'M013F',},  false) || '';

    // ブラウザ・ヘッダータイトル
    const screenName = this.messageProvider.getMessageString({messageId: 'SMS009' + this.lngType + 'M001T',}) || '';
    const companyName = this.messageProvider.getMessageString({messageId: 'SMS999' + this.lngType + 'M001T',}) || '';
    this.titleService.setTitle(screenName + ' | ' + companyName);
    document.getElementById('lblScreenTitle')!.innerText = screenName;

    this.logger.debug(this.dispId + ' ■ 09 end---- getInitApiReturnInfo');
    return;
  }


  /* **************************************************************
   * 送信ボタン押下
   * **************************************************************/
  executeClick(): void {
    try {
      // ログ出力
      this.logger.info('SMS00901M005I', this.dispId, Const_SMS009.BTN_EXECUTE_NAME);

      // スナックバーを閉じる
      this.screenMessage.closeMessage();

      // 画面入力チェック
      if (!this.inputCheck()) {
        return;
      }

      // 画面項目制御
      this.enabledChange(false);

      // 氏名変更登録API処理 呼出
      this.doEexecute(Const_SMS009.API_EXECUTE_PATH, Const_SMS009.BTN_EXECUTE_NAME);

    } catch (ex) {
      this.logger.error('SMS00901M002E', this.dispId, Const_SMS009.BTN_EXECUTE_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 画面入力チェック
   * @returns true/false
   */
  inputCheck(): boolean {
    let isRet = true;
    const messageStack = new MessageStackService(MessageLevel.ERROR);

    this.logger.debug(this.dispId + ' ■ 09 入力チェック開始');

    // ------------------------------------------
    // 必須チェック
    // ------------------------------------------
    // 氏名_姓
    if (this.stringUtil.isEmpty(this.smsForm.controls.txtNameSei.value)) {
      this.logger.debug('■ 09 姓：必須NG');
      this.smsForm.controls.txtNameSei.setErrors({required: true,});
      this.smsForm.controls.txtNameSei.markAsDirty();
      isRet = false;
    }
    // 氏名_名
    if (this.stringUtil.isEmpty(this.smsForm.controls.txtNameMei.value)) {
      this.logger.debug('■ 09 名：必須NG');
      this.smsForm.controls.txtNameMei.setErrors({required: true,});
      this.smsForm.controls.txtNameMei.markAsDirty();
      isRet = false;
    }
    // 氏名_セイ
    if (this.stringUtil.isEmpty(this.smsForm.controls.txtKanaSei.value)) {
      this.logger.debug('■ 09 セイ：必須NG');
      this.smsForm.controls.txtKanaSei.setErrors({required: true,});
      this.smsForm.controls.txtKanaSei.markAsDirty();
      isRet = false;
    }
    // 氏名_メイ
    if (this.stringUtil.isEmpty(this.smsForm.controls.txtKanaMei.value)) {
      this.logger.debug('■ 09 メイ：必須NG');
      this.smsForm.controls.txtKanaMei.setErrors({required: true,});
      this.smsForm.controls.txtKanaMei.markAsDirty();
      isRet = false;
    }

    // ------------------------------------------
    // 全角チェック
    // ------------------------------------------
    // 氏名_姓
    if (!this.validationService.isSeiZenkaku(this.smsForm.controls.txtNameSei.value)) {
      this.logger.debug('■ 09 姓：isSeiZenkaku NG');
      this.smsForm.controls.txtNameSei.setErrors({isSeiZenkaku: true,});
      this.smsForm.controls.txtNameSei.markAsDirty();
      isRet = false;
    }
    // 氏名_名
    if (!this.validationService.isMeiZenkaku(this.smsForm.controls.txtNameMei.value)) {
      this.logger.debug('■ 09 姓：isMeiZenkaku NG');
      this.smsForm.controls.txtNameMei.setErrors({isMeiZenkaku: true,});
      this.smsForm.controls.txtNameMei.markAsDirty();
      isRet = false;
    }
    // ------------------------------------------
    // 全角カナチェック
    // ------------------------------------------
    // 氏名_セイ
    if (!this.validationService.isSeiKana(this.smsForm.controls.txtKanaSei.value)) {
      this.logger.debug('■ 09 セイ：isSeiKana NG');
      this.smsForm.controls.txtKanaSei.setErrors({isSeiKana: true,});
      this.smsForm.controls.txtKanaSei.markAsDirty();
      isRet = false;
    }
    // 氏名_メイ
    if (!this.validationService.isMeiKana(this.smsForm.controls.txtKanaMei.value)) {
      this.logger.debug('■ 09 メイ：isMeiKana NG');
      this.smsForm.controls.txtKanaMei.setErrors({isMeiKana: true,});
      this.smsForm.controls.txtKanaMei.markAsDirty();
      isRet = false;
    }

    // ------------------------------------------
    // 入力チェック結果判定
    // ------------------------------------------
    if (isRet) {
      // 入力チェックOK
      this.logger.info('SMS99901M004I', this.dispId);
    } else {
      // 入力チェックNG
      this.logger.info('SMS99901M005I', this.dispId);
      messageStack.add({messageId: 'SMS999' + this.lngType + 'M011E',});
      this.screenMessage.showMessage(messageStack);
    }

    this.logger.debug(this.dispId + ' ■ 09 入力チェック終了');

    return isRet;
  }

  /**
   * 氏名変更登録API処理
   * @param {string} path パスAPI
   * @param {string} btnName ボタン名
   */
  private doEexecute(path: string, btnName: string): void {

    // ログ出力
    this.logger.info('SMS00901M001I', this.dispId, btnName);
    this.logger.debug(this.dispId + ' ■ 09 start-- doEexecute');

    // APIパラメータ設定
    const apiVo = {
      keiyakuInfoId: this.loginUserVO.keiyakuInfoId,
      shouninNo: this.loginUserVO.shouninNo,
      sei:  this.smsForm.value.txtNameSei,
      mei:  this.smsForm.value.txtNameMei,
      seiKana:  this.smsForm.value.txtKanaSei,
      meiKana:  this.smsForm.value.txtKanaMei,
    }

    // ログ出力（API入力情報）
    this.logger.debug(this.dispId + ' ■ 09 URL：[' + path + ']');
    this.logger.debug(this.dispId + ' ■ 09 ApiIn   keiyakuInfoId：' + apiVo.keiyakuInfoId);
    this.logger.debug(this.dispId + ' ■ 09 ApiIn   shouninNo    ：' + apiVo.shouninNo);
    this.logger.debug(this.dispId + ' ■ 09 ApiIn   sei          ：' + apiVo.sei);
    this.logger.debug(this.dispId + ' ■ 09 ApiIn   mei          ：' + apiVo.mei);
    this.logger.debug(this.dispId + ' ■ 09 ApiIn   seiKana      ：' + apiVo.seiKana);
    this.logger.debug(this.dispId + ' ■ 09 ApiIn   meiKana      ：' + apiVo.meiKana);

    // 氏名変更登録API
    this.logger.info('SMS00901M003I', this.dispId, btnName);
    this.httpClient.post<SMS009NameUpdateOutVO>(path, apiVo).subscribe({
      next: (resp) => {
        this.logger.info('SMS00901M004I', this.dispId, btnName);
        if (resp != null) {
          // 手続き完了画面に遷移
          this.nextPage();

        } else {
          // エラー画面へ遷移（予期せぬエラー）
          this.logger.error('SMS00901M003E', this.dispId);
          const messageStack = new MessageStackService(MessageLevel.ERROR);
          messageStack.add({messageId: 'SMS99901M013E',});
          this.transitErrPage(messageStack);
        }
        return;
      },
      error: (err: MessageStackService | Error) => {
        this.logger.error('SMS00901M004E', this.dispId);

        // Errorの場合
        if (err instanceof Error) {
          this.commonException(err);
          return;
        }
        // MessageStackの場合
        if (err instanceof MessageStackService && err.messages.length > 0) {
          const messageStack: MessageStackService = new MessageStackService(MessageLevel.ERROR);
          for (const messageError of err.messages) {
            this.logger.debug(this.dispId + ' ■ 09 messageId ：' + messageError.messageId);
            this.logger.error(messageError.messageId);
            messageStack.add({messageId: messageError.messageId,});
          }
          // エラー画面へ遷移
          this.transitErrPage(messageStack);
          return;
        }
      },
    });
  }

  /**
   * 画面遷移処理
   */
  nextPage(): void{
    this.logger.debug(this.dispId + ' ■ 09 → 10 画面遷移');
    this.windowService.transit<null>('SMS010', null);
  }

  /* **************************************************************
   * メニューへ戻るボタン押下
   * **************************************************************/
  backClick(): void {
    try {
      // ログ出力
      this.logger.info('SMS00901M005I', this.dispId, Const_SMS009.BTN_BACKMENU_NAME);

      // スナックバーを閉じる
      this.screenMessage.closeMessage();

      // SMS001：メインメニュー画面に遷移
      this.smsMenuPage.transition(this.loginUserVO.hashId,
                                  this.loginUserVO.menuNo,
                                  this.loginUserVO.languageType);

    } catch (ex) {
      this.logger.error('SMS00901M002E', this.dispId, Const_SMS009.BTN_BACKMENU_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 共通例外処理
   * @param {Error} err
   */
  private commonException(err?: Error | unknown): void {

    this.logger.debug(this.dispId + ' ■ 09 共通例外処理開始');

    // エラーログ
    if (err instanceof Error) {
      this.logger.errorWithFreeText(SystemConstant.UNEXPECTED_ERROR, err.message, this.dispId);
    } else {
      this.logger.errorWithFreeText(SystemConstant.UNEXPECTED_ERROR, err, this.dispId);
    }

    // エラー画面へ遷移（予期せぬエラー）
    const messageStack = new MessageStackService(MessageLevel.ERROR);
    messageStack.add({messageId: 'SMS99901M013E',});
    this.transitErrPage(messageStack);
  }

  /**
   * エラー画面へ遷移
   * @param {MessageStackService} messageStack
   */
  transitErrPage(messageStack: MessageStackService): void {

    // SMS011：エラー画面に遷移
    this.smsErrPage.transition(messageStack,
                               this.loginUserVO.hashId,
                               this.loginUserVO.menuNo,
                               this.loginUserVO.languageType);
  }

  /**
   * 画面項目の制御
   * @param {boolean} isEnabledFlg
   */
  enabledChange(isEnabledFlg: boolean): void {
    this.isEnableBtnSend = isEnabledFlg;
    this.isEnableBtnMenu = isEnabledFlg;
  }

}
